import { convertYupErrorToObject } from '@shared/utils/validation.utils';
import * as yup from 'yup';
import { initialState as initialFilterState } from './dashboard-filters.state';

const dateRangeSchema = yup.object().shape({
    startDate: yup.date().required(),
    endDate: yup.date().required(),
    key: yup.string().required(),
});

const metricPositionSchema = yup.object().shape({
    isSelected: yup.boolean().required(),
    metric: yup.object()
        .shape({
            color: yup.string(),
            label: yup.string(),
            value: yup.string(),
            type: yup.string(),
        })
        .required(),
});

const dashboardFiltersSchema = yup.object().shape({
    ranges: yup.object().shape({
        date: dateRangeSchema.required(),
        comparisonDate: dateRangeSchema.default(undefined),
    }),
    conversionType: yup.string().required(),
    segmentation: yup.string().required(),
    selectedCampaigns: yup.array().of(yup.number()),
    metrics: yup.object().shape({
        firstMetric: metricPositionSchema,
        secondMetric: metricPositionSchema,
    }),
    period: yup.array().of(yup.string()),
});

export const validateAndFormatDashboardFilters = config => dashboardFiltersSchema
    .validate(config)
    .catch((err) => {
        const errors = convertYupErrorToObject(err);

        const getCorrectValue = key => (Object.keys(errors).includes(key)
            ? initialFilterState[key] : config[key]);

        const result = Object.keys(config).reduce(
            (acc, curr) => ({
                ...acc,
                [curr]: getCorrectValue(curr),
            }),
            {},
        );

        return result;
    })
    .then(formatDashboardFilters);

const formatDashboardFilters = (filters) => {
    try {
        const { ranges } = filters;

        const formatted = {
            ...filters,
            ranges: {
                date: formatStartAndEndDate(ranges.date),
            },
        };

        if (ranges.comparisonDate) {
            return {
                ...formatted,
                ranges: {
                    ...formatted.ranges,
                    comparisonDate: formatStartAndEndDate(
                        ranges.comparisonDate,
                    ),
                },
            };
        }
        return formatted;
    } catch (e) {
        return {
            ...filters,
            ranges: initialFilterState.ranges,
        };
    }
};

const formatStartAndEndDate = ({ startDate, endDate, key }) => ({
    startDate: new Date(startDate),
    endDate: new Date(endDate),
    key,
});
